import React, {useCallback} from "react";
import {Linking, Platform, useWindowDimensions, View, ScrollView} from "react-native";
import {useNavigation} from "@react-navigation/native";
import {breakpoint, isFullSwing} from "../../constants";
import SupportGuideHeader from "../../components/SupportGuideHeader";
import MainStyle from "../../../MainStyle";
import {colors} from "../../assets/styles/colors";
import SupportGuideButtonMenu from "../../components/SupportGuideButtonMenu";
import {NativeStackNavigationProp} from "@react-navigation/native-stack";
import FSHeader from "../../components/FSHeader";
import {PrivacyPolicyTextProvider} from "./PrivacyPolicyText";
import IntroductionSection from "./sections/IntroductionSection";
import InformationCollectionSection from "./sections/InformationCollectionSection";
import InformationProvidedSection from "./sections/InformationProvidedSection";
import AutomaticDataCollectionSection from "./sections/AutomaticDataCollectionSection";
import UseAndDisclosureSection from "./sections/UseAndDisclosureSection";
import ChoicesAndSecuritySection from "./sections/ChoicesAndSecuritySection";
import BiometricPrivacySection from "./sections/BiometricPrivacySection";
import CaliforniaPrivacySection from "./sections/CaliforniaPrivacySection";
import NoticeAtCollectionSection from "./sections/NoticeAtCollectionSection";

type Props = { onExit?: () => void };

const PrivacyPolicyScreen = ({onExit: onExitOverride}: Props = {}) => {
  const navigation: NativeStackNavigationProp<any> = useNavigation();
  const {width} = useWindowDimensions();
  const isSm = width < breakpoint;

  const openLink = (url: string) => {
    if (Platform.OS === 'web') window.open(url, '_blank', 'noopener,noreferrer');
    else Linking.openURL(url).then();
  };

  const onExit = useCallback(() => {
    if (onExitOverride) {
      onExitOverride();
      return;
    }

    if (navigation.canGoBack()) navigation.goBack();
    else navigation.navigate('challenges');
  }, [navigation, onExitOverride]);

  const navigateToNotifications = () => navigation.navigate('Notifications');

  return (
    <PrivacyPolicyTextProvider isSm={isSm} openLink={openLink} navigateToNotifications={navigateToNotifications}>
      {isFullSwing ? (
        <FSHeader
          title="Privacy Policy" goBack={onExit} hideLogo hideGameLogo hideAccount hideBalance hideMenu px={20}
        />
      ) : (
        <SupportGuideHeader title="Privacy Policy" onExit={onExit}/>
      )}

      <ScrollView keyboardShouldPersistTaps="handled"
                  contentContainerStyle={[MainStyle.min_h_full, {
                    backgroundColor: isFullSwing ? 'transparent' : colors.bg_contest, paddingBottom: isSm ? 27 : 92
                  }]}>
        <View style={[MainStyle.max_w_1120, MainStyle.full_w, {
          alignSelf: 'center', paddingTop: isSm ? 17 : 27, paddingHorizontal: isSm ? 40 : 0
        }]}>
          <IntroductionSection/>
          <InformationCollectionSection/>
          <InformationProvidedSection/>
          <AutomaticDataCollectionSection/>
          <UseAndDisclosureSection/>
          <ChoicesAndSecuritySection/>
          <BiometricPrivacySection/>
          <CaliforniaPrivacySection/>
          <NoticeAtCollectionSection/>
        </View>
      </ScrollView>

      {!isSm && <SupportGuideButtonMenu onExit={onExit}/>}
    </PrivacyPolicyTextProvider>
  );
};

export default PrivacyPolicyScreen;
